module.exports = {
      id: "close-usage",
      viewBox: "0 0 14 14.001",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#close",
      toString: function () {
        return this.url;
      }
    }